<template lang="html">
  <div id="header">
    <a href="/"><img src="../assets/soluti.png" width="224" height="64" alt="Soluti - Soluções em Negócios Inteligentes" border="0" class="logo"></a>
    <div id="fone">
       <img src="../assets/fone.png" width="39" height="48" alt="0800 9416601">
       <span>CENTRAL DE ATENDIMENTO</span>
       <div>0800 9416601</div>
     </div>

     <ul id="menu-principal">
       <li><a href="/">Inicial</a></li>
       <li><a href="http://www.soluti.com.br/">Site da Soluti</a></li>
     </ul>
  </div> <!-- header -->

</template>

<script>
export default {
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// Header.vue?e332df52